
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';
    import lista from './lista/lista.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            lista,

        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Vue.observable( Model ); }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public get Vista() { return this.Controlador.Vista; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {


            if ( this.$vuetify.breakpoint.xsOnly )
                this.Vista.Titulo = 'Mensajería';
        }


    }
